import React, { useMemo } from 'react';
import { buildReferenceContent, linkifySegments } from '../../lib/apaSlideFormatter.js';
import { resolveReferencePage } from '../../utils/apaReferenceListUtils';
import ApaSegments from '../../components/ApaSegments';

const ApaReferenceListRenderer = ({ block = {}, autoCitations = [] }) => {
  // The list is paginated across as many slides as it needs; this block shows
  // one page of it.
  const { metas: pageMetas, pageIndex, pageCount } = useMemo(
    () => resolveReferencePage({ ...block, autoCitations }),
    [block, autoCitations]
  );

  // An image or artwork entry carries an italic title, so the list renders the
  // formatter's segments rather than a flat string.
  const formatted = pageMetas
    .map((meta) => {
      const content = buildReferenceContent(meta);
      if (!content) return null;
      const link = meta.doi ? `https://doi.org/${meta.doi}` : meta.url;
      return { segments: linkifySegments(content.segments, link) };
    })
    .filter(Boolean);

  return (
    <div className="my-6 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-slate-800">
          {pageIndex > 0 ? 'References (continued)' : 'References'}
        </h3>
        {pageCount > 1 && (
          <p className="text-xs text-slate-500">Page {pageIndex + 1} of {pageCount}</p>
        )}
      </div>
      {formatted.length > 0 ? (
        <div className="space-y-2 text-sm text-slate-700">
          {formatted.map((item, index) => (
            <div
              key={`reference-${block.id || 'apa'}-${index}`}
              style={{ paddingLeft: '1.5rem', textIndent: '-1.5rem' }}
            >
              <ApaSegments segments={item.segments} />
            </div>
          ))}
        </div>
      ) : (
        <div className="text-sm text-slate-500">
          Add reference items or place APA citation blocks in the presentation to populate this list.
        </div>
      )}
    </div>
  );
};

export default ApaReferenceListRenderer;
